import store from '@/store';
import { accuityRepository } from '@/forms/api/repository-factory';
import getValueByFieldName from '@/forms/helpers/get-value-by-field-name';
import FIELD_NAMES from '@/forms/constants/field-names';
import callApi from '@/lib/helpers/call-api';
import { SET_ACCUITY_RESPONSE } from '@/lib/constants/mutations';
const accuityDateFormat = function(date) {
    var datetoConvert = new Date(date);
    var dobDate = datetoConvert.getDate();
    var dobMonth = datetoConvert.getMonth() + 1;
    var dobYear = datetoConvert.getFullYear();
    let month = '';
    var newdobDate = dobDate < 10 ? '0' + '' + dobDate + '' : '' + dobDate + '';
    let newdobMonth = dobMonth < 10 ? '0' + '' + dobMonth + '' : '' + dobMonth + '';
    return newdobMonth + '.' + newdobDate + '.' + '' + dobYear + '';
};

const getPayload = () => {
    const { values } = store.state.formData;
    const { cifnumber } = store.state;

    const firstName = getValueByFieldName(values, FIELD_NAMES.firstName);
    const lastName = getValueByFieldName(values, FIELD_NAMES.lastName);
    const birthDate = accuityDateFormat(getValueByFieldName(values, FIELD_NAMES.birthDate));
    const nationality = getValueByFieldName(values, FIELD_NAMES.nationality);
    const domicileeCity = getValueByFieldName(values, FIELD_NAMES.emirate);
    const domicileCountry = 'UAE'; //getValueByFieldName(values, FIELD_NAMES.nationality);
    const passportNumber = getValueByFieldName(values, FIELD_NAMES.passportNumber);

    return {
        "ApiName": "importScreeningService",
        //"DatasetGUID": "medium",
        "uniqueId": cifnumber,
        "ClientFullName": firstName + " " + lastName,
        "ClientEntityType": "Individual",
        "DateOfBirth": birthDate,
        "Nationality": nationality,
        "DomicileCity": domicileeCity,
        "DomicileCountry": domicileCountry,
        "PassportOrIdNo": typeof passportNumber !== 'undefined' ? passportNumber : "",

    };
};

export default {
    async accuity(currentStep, callbacks) {
        const { form } = currentStep;
        let response = false;
        response = await callApi({
            callbacks,
            form,
            formElement: currentStep,
            apiCall: accuityRepository.accuity,
            payload: getPayload(),
        });
        if (response) {
            const accuityResponse = response;
            store.commit(SET_ACCUITY_RESPONSE, { accuityResponse });
        }
    }
};